import { render, staticRenderFns } from "./BlogEdit.vue?vue&type=template&id=2196f967"
import script from "./BlogEdit.vue?vue&type=script&lang=js"
export * from "./BlogEdit.vue?vue&type=script&lang=js"
import style0 from "./BlogEdit.vue?vue&type=style&index=0&id=2196f967&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports